import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';
import { ManageEventsComponent } from './manage-events/manage-events.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';

@Component({
  selector: 'community-events',
  templateUrl: './events.component.html',
  styleUrls: ['events.component.scss']
})
export class EventsComponent implements OnInit {

  @ViewChild("ManageEvents") manageEvents: ManageEventsComponent;
  public imgUrl = environment.ImageUrl;
  public allEvents: Array<any> = [];
  public carouselOptions: any = {
    nav: true,
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    margin: 10,
    autoWidth: true,
  };
  public selectedMemberRegion: string = 'default';
  public width: number = 0;
  public commonModalRef: any;
  public selectedEvent: any = null;

  constructor(public roleService: RoleService, private toastr: ToastrService, private auth: AuthServiceService, private modalService: NgbModal, public commonService: CommonService,
    @Inject("WINDOW") private window: any,
  ) {
    this.width = this.window.innerWidth;
  }

  ngOnInit(): void {
    this.getAllEvents();
  }


  public getAllEvents() {
    this.auth.getAllEvents().subscribe((resp: ApiResponse) => {
      let output = [];
      for (let i of resp.body) {
        let paresData = 0;
        try {
          paresData = JSON.parse(i.registeredMembers).length;
        } catch (e) {
          paresData = 0;
        }
        output.push({ ...i, registeredMembers: paresData });
      }
      this.allEvents = output.map((i: any) => {
        i['subRegion'] = i.subRegion && i.subRegion.includes('|') ? i.subRegion.split('|').map((i) => this.commonService.getSubregionName(i)) : [i.subRegion]
        return i;
      });

    });
  }

  public add() {
    this.manageEvents.openProductCharForAddEdit();
  }

  public join(id) {
    this.auth.joinEvent({ id: id }).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.getAllEvents();
    }, ({ error }: any) => {
      this.toastr.error(error.message);
    });
  }
  convertDate(value: number) {
    return moment(value).format('MMMM D, YYYY');
  }
  public view(modal, selectedEvent: any) {
    this.selectedEvent = selectedEvent;
    this.commonModalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public goto(url: any) {
    window.open(url.includes("https://") ? url : "Https://" + url, '_blank');
  }
}
